//This component is deprecated.
//Use Next SSR instead for sessions.
const ClientSessionHandler = ({children}) => {
  return (
    <>
      {children}
    </>
  );    
};

export default ClientSessionHandler;